import rill from "rill";
import getMembershipList from "./membership-list.controller";
import { checkOrganizationSectionPermission } from "../../../middleware/ensure-coach-permissions";

const MembershipList = (app) => {
  app.at(
    "/memberships/*",
    rill().setup((app) => {
      app.get(
        "/",
        (ctx, next) =>
          checkOrganizationSectionPermission(
            ctx,
            next,
            ["PRESS"],
            "/coaching-portal/athletes"
          ),
        getMembershipList
      );
    })
  );
};

export default MembershipList;
